// import

import type {IconDefinition} from '@fortawesome/fontawesome-svg-core';
import {styled} from 'goober';
import type {SVGAttributes} from 'react';
import {forwardRef} from 'react';

// types

type Props = SVGAttributes<SVGSVGElement> & {
  icon: IconDefinition;
  size?: number | string;
  width?: number | string;
  height?: number | string;
  title?: string;
};

// styles

// eslint-disable-next-line prefer-arrow-callback
export const FontAwesome = styled(function Icon(props: Props) {
  const {icon, size = '1em', width, height, title, children, ...rest} = props;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {iconName, icon: [w, h, _lig, _uni, path]} = icon;

  return (
    <svg
      {...rest}
      height={height ?? size}
      viewBox={`0 0 ${w} ${h}`}
      width={width ?? size}
    >
      <title>{title || iconName}</title>
      <path d={path as string} fill="currentColor" />
    </svg>
  );
}, forwardRef)`
  display: inline-block;
  overflow: visible;
  vertical-align: -0.125em;
  text-align: center;
  font-size: inherit;
`;
